<template>
  <section class="mb-20">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-900 mb-4">七维度性格模型</h2>
      <p class="text-lg text-gray-600 max-w-2xl mx-auto">
        从多个角度全面分析你的性格特征，找到最匹配的动物原型
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
      <!-- 支配性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-red-100">
        <div class="p-6">
          <div class="text-5xl mb-3">👑</div>
          <h3 class="font-semibold mb-2 text-lg text-red-600">支配性</h3>
          <p class="text-sm text-gray-600">
            领导力、控制欲、统御能力
          </p>
        </div>
      </div>

      <!-- 策略性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-purple-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🧠</div>
          <h3 class="font-semibold mb-2 text-lg text-purple-600">策略性</h3>
          <p class="text-sm text-gray-600">
            智慧、谋略、解决问题能力
          </p>
        </div>
      </div>

      <!-- 社群性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-amber-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🤝</div>
          <h3 class="font-semibold mb-2 text-lg text-amber-600">社群性</h3>
          <p class="text-sm text-gray-600">
            社交能力、团队合作、归属感
          </p>
        </div>
      </div>

      <!-- 独处性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-cyan-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🌙</div>
          <h3 class="font-semibold mb-2 text-lg text-cyan-600">独处性</h3>
          <p class="text-sm text-gray-600">
            独立性、享受独处、自我满足
          </p>
        </div>
      </div>

      <!-- 敏捷性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-psychology-primary-10">
        <div class="p-6">
          <div class="text-5xl mb-3">⚡</div>
          <h3 class="font-semibold mb-2 text-lg text-psychology-primary">敏捷性</h3>
          <p class="text-sm text-gray-600">
            灵活性、适应性、反应速度
          </p>
        </div>
      </div>

      <!-- 安全性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-psychology-info-10">
        <div class="p-6">
          <div class="text-5xl mb-3">🛡️</div>
          <h3 class="font-semibold mb-2 text-lg text-psychology-info">安全性</h3>
          <p class="text-sm text-gray-600">
            安全感需求、稳定性、警惕性
          </p>
        </div>
      </div>

      <!-- 美学性 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-pink-100 md:col-span-2 lg:col-span-2">
        <div class="p-6">
          <div class="text-5xl mb-3">🌸</div>
          <h3 class="font-semibold mb-2 text-lg text-pink-600">美学性</h3>
          <p class="text-sm text-gray-600">
            对美的追求、优雅、理想主义
          </p>
        </div>
      </div>
    </div>

    <!-- 计算方法说明 -->
    <div class="mt-12 max-w-3xl mx-auto bg-gradient-to-r from-purple-50 to-psychology-info-10 rounded-2xl p-8 border border-purple-200">
      <div class="flex items-start gap-4">
        <div class="text-4xl">🔬</div>
        <div>
          <h3 class="text-xl font-bold text-gray-800 mb-2">科学的匹配算法</h3>
          <p class="text-gray-600 leading-relaxed">
            我们使用<strong>余弦相似度</strong>算法，将你在七个维度的得分与25种动物原型进行匹配，
            通过<strong>L2归一化</strong>和<strong>向量匹配</strong>技术，找出与你性格最接近的动物。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DimensionsSection'
}
</script>

<style scoped>
.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
</style>
